

          /**
           * Escapes a value for interpolation into an HTML string.
           * @param {*} value
           * @return {string}
           */
          function esc(value) {
            return String(value == null ? '' : value)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;')
              .replace(/'/g, '&#39;');
          }

          /**
           * @extends storeLocator.StaticDataFeed
           * @constructor
           */
          function MedicareDataSource() {
            $.extend(this, new storeLocator.StaticDataFeed);

            if( storesObj.stores.length < 1 ) return;
            console.log('load stores json');
            console.log(storesObj.stores);
            this.setStores(this.parse_(storesObj));
          }

          /**
           * @const
           * @type {!storeLocator.FeatureSet}
           * @private
           */


          /**
           * @return {!storeLocator.FeatureSet}
           */
          MedicareDataSource.prototype.getFeatures = function() {
            return this.FEATURES_;
          };
          /**
           * @private
           * @param {string} csv
           * @return {!Array.<!storeLocator.Store>}
           */
          MedicareDataSource.prototype.parse_ = function(csv) {
            var stores = [];
            // var storesCSV = JSON.parse(csv);
            // console.log(storesCSV);
            var storesCSV = csv;
            console.log(storesCSV);
            for(var i = 0; i < storesCSV.stores.length; i++)
            {
              var features = new storeLocator.FeatureSet;

              var storeData = storesCSV.stores[i];
              //console.log(storeData.Fcilty_nam);
              var position = new google.maps.LatLng(storeData.Ycoord, storeData.Xcoord);
              var locality = this.join_([storeData.Postcode, storeData.Locality], '<br>');
              var phone = storeData.Phone_number.replace(/[^0-9]/g, '');

              // Accessible names must identify which restaurant the control acts on
              // (WCAG 2.4.4). The location name is appended in a visually hidden span so
              // the visible label stays the start of the accessible name (WCAG 2.5.3).
              var storeName = storeData.Fcilty_nam || '';
              var forStore = storeName ? '<span class="visually-hidden"> \u2014 ' + esc(storeName) + '</span>' : '';

              var btn = '';
              if (storeData.url !== "") {
                  btn = '<a rel="noopener" href="' + esc(storeData.url) + '" class="button store-location">Order Online' + forStore + '</a>';
              }
              if (storeData.Email !== "") {
                  // Leaves the site and opens in a new tab - say so in the accessible name (WCAG 2.4.4 / G201).
                  btn = this.join_([btn, '<a rel="noopener noreferrer" href="' + esc(storeData.Email) + '" class="button" target="_blank">Get Directions'
                      + '<span class="visually-hidden">' + (storeName ? ' to ' + esc(storeName) : '') + ' (opens in a new tab)</span></a>'], ' ');
              }

              var btns = '';
              if (storeData.Page !== "") {
                btns = '<a rel="noopener" href="'+ esc(storeData.Page) +'" class="button store-location">Learn More'
                    + (storeName ? '<span class="visually-hidden"> about ' + esc(storeName) + '</span>' : '') + '</a>';
              }

              // The storefront photo repeats the name and address that sit next to it, so it
              // is decorative and is hidden from assistive technology (WCAG 1.1.1).
              var image = storeData.Image ? '<img alt="" src="'+ esc(storeData.Image) +'">' : '';

              // Only render a tel: link when there is a number to call; the "open / coming
              // soon" badge is status text, not a phone number, so it is never a link.
              var phoneHtml = phone
                ? '<a href="tel:'+ esc(phone) +'">'+ esc(storeData.Phone_number) + (storeName ? '<span class="visually-hidden"> \u2014 ' + esc(storeName) + '</span>' : '') + '</a>'
                : '';

            var store = new storeLocator.Store(storeData.uuid, position, features, {
                image: image,
                title: storeName,
                address: this.join_([storeData.Street_add, locality], '<br>'),
                phone: phoneHtml,
                fax: storeData.Fax_number,
                page: btns,
                email: btn
              });
              stores.push(store);
            }
            return stores;

          };

          /**
           * Joins elements of an array that are non-empty and non-null.
           * @private
           * @param {!Array} arr array of elements to join.
           * @param {string} sep the separator.
           * @return {string}
           */
          MedicareDataSource.prototype.join_ = function(arr, sep) {
            var parts = [];
            for (var i = 0, ii = arr.length; i < ii; i++) {
              arr[i] && parts.push(arr[i]);
            }
            return parts.join(sep);
          };

          /**
           * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
           * IMPORTANT: Don't use this for general CSV parsing!
           * @private
           * @param {string} row
           * @return {Array.<string>}
           */
          MedicareDataSource.prototype.parseRow_ = function(row) {
            // Strip leading quote.
            if (row.charAt(0) == '"') {
              row = row.substring(1);
            }
            // Strip trailing quote. There seems to be a character between the last quote
            // and the line ending, hence 2 instead of 1.
            if (row.charAt(row.length - 2) == '"') {
              row = row.substring(0, row.length - 2);
            }

            row = row.split('","');

            return row;
          };

          /**
           * Creates an object mapping headings to row elements.
           * @private
           * @param {Array.<string>} headings
           * @param {Array.<string>} row
           * @return {Object}
           */
          MedicareDataSource.prototype.toObject_ = function(headings, row) {
            var result = {};
            for (var i = 0, ii = row.length; i < ii; i++) {
              result[headings[i]] = row[i];
            }
            return result;

          };

